export const AmbikaChefAPI =  "https://www.erp.ambikadairyfarm.com/api"